<template>
    <div class="col-md-12">
        <ManageGroups></ManageGroups>
        <ManagePriorities></ManagePriorities>
        <ManageStatus></ManageStatus>
        <ManageReasons></ManageReasons>
    </div>
</template>

<script>
import ManageGroups from './groups/ManageGroups.vue';
import ManagePriorities from './priorities/ManagePriorities.vue';
import ManageStatus from './statuses/ManageStatus.vue';
import ManageReasons from './reasons/ManageReasons.vue';

export default {
    name: "ConfigTasks",
    components: {
        ManageGroups,
        ManagePriorities,
        ManageStatus,
        ManageReasons
    },
    data() {
        return {}
    },
}
</script>
